import { AddFilter16 } from 'ui/icons/aurora/16px/AddFilter16';
import { BUTTON_VARIANTS } from 'ui/button';
import { ButtonProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { QueryBuilderIconButton } from './QueryBuilderIconButton';

export const DATA_TEST = {
  button: 'add-condition-button',
};

export const AddConditionButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderIconButton
      {...props}
      variant={BUTTON_VARIANTS.GHOST}
      dataTest={DATA_TEST.button}
      tooltipContent={t('storybook.buttons.addCondition')}
      Icon={AddFilter16}
    />
  );
};
